// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"50":"datadogProfiler","133":"datadogRecorder"}[chunkId] + "." + {"50":"4667c955","133":"2a062516"}[chunkId] + ".chunk.js";
};